type Listener = (hidden: boolean) => void;
let hidden = false;
let listeners: Listener[] = [];

export const navbarState = {
  setHidden: (val: boolean) => {
    hidden = val;
    listeners.forEach(l => l(val));
  },
  subscribe: (fn: Listener) => {
    listeners.push(fn);
    return () => { listeners = listeners.filter(l => l !== fn); };
  },
  getHidden: () => hidden,
};